import React from 'react';
import styled from 'styled-components';
import { HoDDoSApplicationList } from './components';
import { PAGE_TEXT } from '../lang';

export const HoDDoSAssessment: React.FunctionComponent = () => {
  return (
    <PageContainer>
      <h1>{PAGE_TEXT.TO_DO_LIST.TITLE}</h1>
      <div className="p-[2rem]">
        <HoDDoSApplicationList />
      </div>
    </PageContainer>
  );
};

const PageContainer = styled.div`
  width: 100%;

  h1 {
    font-size: 1.5rem;
    font-weight: 700;
    margin-top: 2rem;
    text-align: center;
    color: #951d1d;
  }
`;
